<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <div class="overlay" :class="{loading}">
    <slot></slot>
    <div class="overlay-content" v-if="loading">
      <div class="spinner-border text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>